import { useTranslation } from 'react-i18next';
import { useIsHongKongIp } from '../../hooks/useIsHongKongIp';

type CopyBlock = {
  eyebrow: string;
  title: string;
  paragraphs: string[];
  highlights: Array<{ label: string; value: string }>;
  tags: string[];
};

const unrestrictedContent: Record<'hk' | 'cn' | 'en' | 'ug' | 'vn', CopyBlock> = {
  vn: {
    eyebrow: 'Gold Label Global | Dịch vụ giao dịch kim loại quý tại Hồng Kông',
    title: 'Gold Label Global Limited — Nền tảng thông tin giao dịch vàng và bạc tại Hồng Kông',
    paragraphs: [
      'Gold Label Global Limited (JLBHK) cung cấp thông tin rõ ràng về giao dịch kim loại quý, quy trình mở tài khoản, hướng dẫn nạp và rút tiền cùng dịch vụ hỗ trợ nền tảng MT5.',
      'Trang web bao gồm thông tin về giao dịch vàng tại Hồng Kông, thị trường bạc, thông số hợp đồng kim loại quý, giờ giao dịch, yêu cầu ký quỹ và quản trị rủi ro, giúp nhà đầu tư tìm hiểu dịch vụ của Gold Label Global bằng tiếng Việt.',
    ],
    highlights: [
      { label: 'Thông tin thương hiệu', value: 'Gold Label Global Limited / JLBHK' },
      { label: 'Thông tin sản phẩm', value: 'Vàng, bạc và thị trường kim loại quý' },
      { label: 'Hỗ trợ nền tảng', value: 'MT5, mở tài khoản, quy trình nạp và rút tiền' },
    ],
    tags: ['Gold Label Global', 'JLBHK', 'Giao dịch vàng', 'Thị trường bạc', 'Giao dịch kim loại quý'],
  },
  hk: {
    eyebrow: '金利寶環球｜香港貴金屬交易服務',
    title: '金利寶環球（Gold Label Global Limited）— 香港黃金與白銀交易資訊平台',
    paragraphs: [
      '金利寶環球，亦可搜尋「金利寶」、「香港金利寶」、「金利寶黃金」或「金利寶環球 Gold Label Global Limited」，致力為客戶提供清晰的貴金屬交易資訊、開戶流程、出入金指引及 MT5 平台支援。',
      '網站內容涵蓋香港黃金交易、白銀市場、貴金屬合約規格、交易時間、保證金要求及風險管理提示，方便投資者以中文了解金利寶相關服務。',
    ],
    highlights: [
      { label: '品牌搜尋', value: '金利寶、金利寶環球、香港金利寶' },
      { label: '產品資訊', value: '金利寶黃金、白銀及貴金屬市場' },
      { label: '平台支援', value: 'MT5 交易平台、開戶、出入金流程' },
    ],
    tags: ['金利寶', '金利寶環球', '香港金利寶', '金利寶黃金', '香港黃金交易', '貴金屬交易'],
  },
  cn: {
    eyebrow: '金利宝环球｜香港贵金属交易服务',
    title: '金利宝环球（Gold Label Global Limited）— 香港黄金与白银交易资讯平台',
    paragraphs: [
      '金利宝环球，亦可搜索“金利宝”、“香港金利宝”、“金利宝黄金”或“金利宝环球 Gold Label Global Limited”，致力为客户提供清晰的贵金属交易资讯、开户流程、出入金指引及 MT5 平台支持。',
      '网站内容涵盖香港黄金交易、白银市场、贵金属合约规格、交易时间、保证金要求及风险管理提示，方便投资者以中文了解金利宝相关服务。',
    ],
    highlights: [
      { label: '品牌搜索', value: '金利宝、金利宝环球、香港金利宝' },
      { label: '产品资讯', value: '金利宝黄金、白银及贵金属市场' },
      { label: '平台支持', value: 'MT5 交易平台、开户、出入金流程' },
    ],
    tags: ['金利宝', '金利宝环球', '香港金利宝', '金利宝黄金', '香港黄金交易', '贵金属交易'],
  },
  en: {
    eyebrow: 'JLBHK Chinese brand information',
    title: 'Gold Label Global Limited — JLBHK / 金利寶環球 precious metals information',
    paragraphs: [
      'Gold Label Global Limited is also searchable by Chinese brand terms including 金利寶, 金利寶環球, 金利宝环球, 香港金利寶 and 金利寶黃金.',
      'The website provides information about Hong Kong gold trading, silver markets, precious metals contract specifications, MT5 platform support, account opening, deposits and withdrawals, and risk notes.',
    ],
    highlights: [
      { label: 'Chinese brand terms', value: '金利寶, 金利寶環球, 金利宝环球' },
      { label: 'Market information', value: 'Gold, silver and precious metals' },
      { label: 'Platform support', value: 'MT5, account opening, deposits and withdrawals' },
    ],
    tags: ['JLBHK', 'Gold Label Global', '金利寶', '金利宝环球', '香港金利寶', 'Gold trading'],
  },
  ug: {
    eyebrow: 'Gold Label Global｜شياڭگاڭ قىممەتلىك مېتال سودا مۇلازىمىتى',
    title: 'Gold Label Global Limited — شياڭگاڭ ئالتۇن ۋە كۈمۈش سودا ئۇچۇر سۇپىسى',
    paragraphs: [
      'Gold Label Global Limited خېرىدارلارغا قىممەتلىك مېتال سودىسى، ھېسابات ئېچىش، مەبلەغ سېلىش ۋە ئېلىش، شۇنداقلا MT5 سۇپىسىغا مۇناسىۋەتلىك ئېنىق ئۇچۇر بىلەن تەمىنلەيدۇ.',
      'تور بېكەت شياڭگاڭ ئالتۇن سودىسى، كۈمۈش بازىرى، قىممەتلىك مېتال توختام ئۆلچىمى، سودا ۋاقتى، كاپالەت پۇلى تەلىپى ۋە خەۋپ باشقۇرۇش ئۇچۇرلىرىنى ئۆز ئىچىگە ئالىدۇ.',
    ],
    highlights: [
      { label: 'ماركا ئۇچۇرى', value: 'Gold Label Global Limited ۋە JLBHK' },
      { label: 'مەھسۇلات ئۇچۇرى', value: 'ئالتۇن، كۈمۈش ۋە قىممەتلىك مېتال بازارلىرى' },
      { label: 'سۇپا قوللىشى', value: 'MT5، ھېسابات ئېچىش، مەبلەغ سېلىش ۋە ئېلىش جەريانى' },
    ],
    tags: ['Gold Label Global', 'JLBHK', 'ئالتۇن سودىسى', 'كۈمۈش بازىرى', 'قىممەتلىك مېتال سودىسى'],
  },
};

const hongKongSafeContent: Record<'hk' | 'cn' | 'en' | 'ug' | 'vn', CopyBlock> = {
  vn: {
    eyebrow: 'Gold Label Global | Thông tin công ty và giấy phép',
    title: 'Thông tin công ty Gold Label Global Limited',
    paragraphs: [
      'Phần này cung cấp thông tin chính thức về công ty Gold Label Global Limited và thương hiệu JLBHK.',
      'Khách truy cập tại Hồng Kông có thể tìm hiểu về công ty, giấy phép, thông báo chính thức, cảnh báo rủi ro và thông tin liên hệ.',
    ],
    highlights: [
      { label: 'Thông tin thương hiệu', value: 'Gold Label Global Limited / JLBHK' },
      { label: 'Thông tin công ty', value: 'Thông tin đăng ký và giấy phép' },
      { label: 'Nội dung trang web', value: 'Giới thiệu công ty, giấy phép, tin tức và liên hệ' },
    ],
    tags: ['Gold Label Global', 'JLBHK', 'Thông tin công ty', 'Thông tin giấy phép', 'Thông báo chính thức'],
  },
  hk: {
    eyebrow: '金利寶環球｜公司及牌照資料',
    title: '金利寶環球（Gold Label Global Limited）公司資訊',
    paragraphs: [
      '金利寶環球，亦可搜尋「金利寶」、「香港金利寶」或「金利寶環球 Gold Label Global Limited」。',
      '香港訪客可於本網站查閱公司背景、牌照資質、官方公告、風險提示及聯絡資料。',
    ],
    highlights: [
      { label: '品牌資料', value: '金利寶、金利寶環球、香港金利寶' },
      { label: '公司資料', value: 'Gold Label Global Limited' },
      { label: '網站內容', value: '公司介紹、牌照、新聞及聯絡資訊' },
    ],
    tags: ['金利寶', '金利寶環球', '香港金利寶', '公司資料', '牌照資質', '官方公告'],
  },
  cn: {
    eyebrow: '金利宝环球｜公司及牌照资料',
    title: '金利宝环球（Gold Label Global Limited）公司资讯',
    paragraphs: [
      '金利宝环球，亦可搜索“金利宝”、“香港金利宝”或“金利宝环球 Gold Label Global Limited”。',
      '香港访客可于本网站查阅公司背景、牌照资质、官方公告、风险提示及联系资料。',
    ],
    highlights: [
      { label: '品牌资料', value: '金利宝、金利宝环球、香港金利宝' },
      { label: '公司资料', value: 'Gold Label Global Limited' },
      { label: '网站内容', value: '公司介绍、牌照、新闻及联系资讯' },
    ],
    tags: ['金利宝', '金利宝环球', '香港金利宝', '公司资料', '牌照资质', '官方公告'],
  },
  en: {
    eyebrow: 'Gold Label Global Limited company information',
    title: 'Gold Label Global Limited — JLBHK company information',
    paragraphs: [
      'Gold Label Global Limited is also searchable by the brand terms 金利寶, 金利寶環球, 金利宝环球 and 香港金利寶.',
      'Visitors in Hong Kong can view company background, licence information, official notices, risk notices and contact details.',
    ],
    highlights: [
      { label: 'Brand information', value: 'Gold Label Global Limited / JLBHK' },
      { label: 'Company details', value: 'Registration and licence information' },
      { label: 'Website content', value: 'Company, licence, news and contact information' },
    ],
    tags: ['JLBHK', 'Gold Label Global', '金利寶', 'Company information', 'Licence information', 'Official notices'],
  },
  ug: {
    eyebrow: 'Gold Label Global｜شىركەت ۋە ئىجازەتنامە ئۇچۇرى',
    title: 'Gold Label Global Limited شىركەت ئۇچۇرى',
    paragraphs: [
      'بۇ بۆلەك Gold Label Global Limited ۋە JLBHK ماركىسىغا مۇناسىۋەتلىك رەسمىي شىركەت ئۇچۇرىنى كۆرسىتىدۇ.',
      'زىيارەتچىلەر شىركەت ئارقا كۆرۈنۈشى، ئىجازەتنامە، رەسمىي ئۇقتۇرۇش، خەۋپ ئەسكەرتىشى ۋە ئالاقە ئۇچۇرىنى كۆرەلەيدۇ.',
    ],
    highlights: [
      { label: 'ماركا ئۇچۇرى', value: 'Gold Label Global Limited ۋە JLBHK' },
      { label: 'شىركەت ئۇچۇرى', value: 'تىزىملاش ۋە ئىجازەتنامە ئۇچۇرى' },
      { label: 'تور بېكەت مەزمۇنى', value: 'شىركەت، ئىجازەتنامە، خەۋەر ۋە ئالاقە ئۇچۇرى' },
    ],
    tags: ['Gold Label Global', 'JLBHK', 'شىركەت ئۇچۇرى', 'ئىجازەتنامە', 'رەسمىي ئۇقتۇرۇش'],
  },
};

function getLanguageKey(language: string): 'hk' | 'cn' | 'en' | 'ug' | 'vn' {
  if (language === 'vn' || language.startsWith('vi')) return 'vn';
  if (language.startsWith('ug')) return 'ug';
  if (language.startsWith('cn') || language.startsWith('zh-cn')) return 'cn';
  if (language.startsWith('en')) return 'en';
  return 'hk';
}

export default function ChineseSeoContent() {
  const { i18n } = useTranslation();
  const { canShowRestrictedContent } = useIsHongKongIp();
  const languageKey = getLanguageKey(i18n.language);
  const copy = canShowRestrictedContent
    ? unrestrictedContent[languageKey]
    : hongKongSafeContent[languageKey];

  return (
    <section className="bg-white py-16" aria-labelledby="jlbhk-seo-intro-title">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-orange-100 bg-gradient-to-br from-orange-50 via-white to-yellow-50 p-8 md:p-12 shadow-sm">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-orange-600 mb-4">
            {copy.eyebrow}
          </p>
          <h2 id="jlbhk-seo-intro-title" className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
            {copy.title}
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_0.7fr] gap-10 items-start">
            <div className="space-y-5 text-gray-700 text-base md:text-lg leading-8">
              {copy.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>

            <dl className="grid grid-cols-1 gap-4">
              {copy.highlights.map((item) => (
                <div key={item.label} className="rounded-2xl bg-white/90 border border-orange-100 p-5 shadow-sm">
                  <dt className="text-sm font-semibold text-orange-600 mb-2">{item.label}</dt>
                  <dd className="text-gray-900 font-medium leading-7">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="mt-8 flex flex-wrap gap-3" aria-label="JLBHK SEO keywords">
            {copy.tags.map((tag) => (
              <span key={tag} className="rounded-full bg-white px-4 py-2 text-sm font-medium text-gray-700 border border-orange-100 shadow-sm">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
